import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import queryString from 'query-string'

import { AuthContainer } from '@/views/Auth/AuthContainer'
import { SLACK_AUTO_OPEN_PARAM } from '@/views/Organizations/components/buttons/manageSlackNotifications.constants'

import './SlackLandingPage.scss'

// Public, unauthenticated "learn more" page for the Balto Slack app — the
// website link on the Slack App Directory listing. Whoever lands here may not
// be signed in (or a Balto customer at all), so it stays presentational: it
// explains what the app does and points admins back into Balto, where the
// org-scoped "Add to Slack" install actually runs. It deliberately does not
// start OAuth here — the install needs an authenticated admin and a target
// organization, neither of which exists in this context.
const SlackLandingPage = () => {
  return (
    <>
      <Helmet>
        <title>Balto for Slack | Balto Cloud</title>
      </Helmet>

      <AuthContainer>
        <div className="slack-landing">
          <h2 className="slack-landing__title">Balto for Slack</h2>

          <p>
            Get the moments that matter delivered to the right manager, in Slack — the instant they
            happen.
          </p>
          <p>
            When an agent raises their hand, a QA dispute is filed, a scorecard fails, or someone is
            mentioned in a call note, Balto sends a direct message that links straight back to the
            call or task. No new tab, no noisy channel.
          </p>

          <h3>How to turn it on</h3>
          <ol className="slack-landing__steps">
            <li>
              An admin opens User Management in Balto and clicks “Manage Slack Notifications.”
            </li>
            <li>Click “Connect Slack” and approve the Balto app in your workspace.</li>
            <li>
              Each manager turns on Slack for the alerts they want in their notification
              preferences.
            </li>
          </ol>

          <p>
            That’s it — from then on each enabled alert arrives as a direct message from Balto,
            linking back to the call or task. You can disconnect anytime from the same screen.
          </p>

          {/* Protected route by design — ProtectedRoute bounces logged-out visitors
              to /login?next=/users and returns them here after sign-in. */}
          <div className="slack-landing__cta">
            <Link
              className="balto-button brand"
              to={`/users?${queryString.stringify({ [SLACK_AUTO_OPEN_PARAM]: true })}`}
            >
              Connect Slack in Balto
            </Link>
          </div>

          <a
            className="slack-landing__secondary"
            href="https://www.balto.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            New to Balto? See how it works
          </a>
          <a
            className="slack-landing__secondary"
            href="https://baltosoftware.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy policy
          </a>
        </div>
      </AuthContainer>
    </>
  )
}

export default SlackLandingPage
